import { followingNode, isText, nextNode } from '.';

//
// Combine all text nodes.
export function normalizeTextNodes(domNode: Node) {
    const end = followingNode(domNode);
    while (domNode && domNode !== end) {
        if (isText(domNode)) {
            while (isText(domNode.nextSibling)) {
                domNode.textContent += domNode.nextSibling.textContent;
                domNode.parentNode.removeChild(domNode.nextSibling);
            }
        }
        domNode = nextNode(domNode);
    }
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/domop/normalizeTextNodes.tsx